<template>
  <div class="retrun-bill">
    <!-- <div style="text-align: right">
      <Print :print-value="printValue" @handleOn="handleOn" />
    </div> -->
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-button
        type="primary"
        :disabled="saving"
        style="position: fixed; right: 10px; z-index: 99"
        @click="submit"
      >保存</el-button>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-scrollbar>
            <el-col :span="8">
              <el-form-item v-if="form.fBillNo" label="退货单号">
                <el-input :value="form.fBillNo" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="送货单" prop="fCkBillNo">
                <el-input
                  :value="form.fCkBillNo"
                  readonly
                  placeholder="请选择"
                  @focus="() => $refs.dlg1.show()"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经销商">
                <el-input :value="form.fDistributor" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单号">
                <el-input :value="form.orderBillNo" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户名称">
                <el-input :value="form.fCustomer" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="退货原因">
                <el-input v-model="form.fDes" type="textarea" :rows="3" />
              </el-form-item>
            </el-col>

            <el-table :data="form.saleRetrunEntrys">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.entrys" height="100%">
                    <el-table-column prop="fBatchNo" label="批号" />
                    <el-table-column
                      prop="fDate_Sc"
                      label="生产日期"
                      :formatter="dateFormat"
                    />
                    <el-table-column prop="fDate_Xd_zw" label="消毒日期" />
                    <el-table-column prop="fRetroactiveNo" label="追溯号" />
                    <el-table-column prop="fPhQty" label="送货数量" />
                    <el-table-column prop="fThQty" label="已退数量" />
                    <el-table-column prop="fKtQty" label="可退数量" />
                    <el-table-column>
                      <template slot="header">
                        <span class="required">退货数量</span>
                      </template>
                      <template slot-scope="scope">
                        <el-input-currency
                          v-model="scope.row.fQty"
                          :scale="0"
                          min="0"
                          @change="fQtyChange(props.row)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="转次品数量">
                      <template slot-scope="scope">
                        <el-input-currency
                          v-model="scope.row.fCpQty"
                          :scale="0"
                          min="0"
                          @change="fCpQtyChange(props.row)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="备注">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.fDes"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column label="产品编码" prop="fNumber" />
              <el-table-column label="产品名称" prop="fName" />
              <el-table-column label="规格" prop="fModel" />
              <el-table-column label="单位" prop="fUnit" />
              <el-table-column label="批号" prop="fBatchNo" />
              <el-table-column label="数量" prop="fOrderQty" />
              <el-table-column label="退货数量" prop="fQty" />
              <el-table-column label="转次品数量" prop="fCpQty" />

            </el-table> </el-scrollbar></el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <el-table-dialog
      ref="dlg1"
      url="SaleRetrun/SaleRetrunBill/DeliveryChoiceEntry"
      placeholder="订单编号/送货单号"
      search-key="fBillNo"
      :columns="[
        { prop: 'fCkBillNo', label: '送货单号' },
        { prop: 'orderBillNo', label: '订单编号' },
        { prop: 'fDistributor', label: '经销商' },
      ]"
      width="50%"
      @ok="fDeliveryIDChange"
    />
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import Print from '../commonPrint/printButton'

function sum(arr) {
  return arr.reduce(function(prev, curr, idx, arr) {
    return prev + curr
  })
}

export default {
  components: {
    Print
  },
  inject: ['getMap'],
  data: function() {
    return {
      form: {
        saleRetrunEntrys: []
      },

      rules: {
        fCkBillNo: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      activeName: 'first',
      printValue: null,
      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {},
  methods: {
    fDeliveryIDChange: async function(item) {
      if (this.form.fDeliveryID) {
        if (item.deliveryID == this.form.fDeliveryID) {
          return
        } else {
          var flg = await this.$ask(
            '送货单号变更，明细数据会重新加载送货单数据，是否继续?'
          )
          if (!flg) return
        }
      }

      this.form.fDeliveryID = item.deliveryID
      this.form.fDistributor = item.fDistributor
      this.form.orderBillNo = item.orderBillNo
      this.form.fCkBillNo = item.fCkBillNo
      this.form.fCustomer = item.fCustomer

      if (item) {
        var postData = { deliveryID: this.form.fDeliveryID }
        if (this.form.fid) {
          postData.saleRetrunID = this.form.fid
        }
        this.$httpPost(
          'SaleRetrun/SaleRetrunBill/GetSaleRetrunEntry',
          postData
        ).then((res) => {
          this.form.saleRetrunEntrys = res.datalist || []
        })
      }
    },
    fQtyChange: function(row) {
      row.fQty = sum(row.entrys.map((x) => x.fQty))
    },
    fCpQtyChange: function(row) {
      row.fCpQty = sum(row.entrys.map((x) => x.fCpQty))
    },

    submit: function() {
      this.$refs.form.validate(async(valid) => {
        const flg = await this.$ask('是否提交?')
        if (!flg) return

        this.saving = true
        this.$httpPost('SaleRetrun/SaleRetrunBill/SaleRetrunStockModify', {
          datalist: JSON.stringify({
            info: this.form,
            modifyType: this.isNew ? 0 : 1
          })
        })
          .then((res) => {
            if (!res.isSuccess) {
              this.$message.error(res.message)
              return
            }

            // 重新刷新页面数据
            this.$message.success(res.message)

            if (this.$route.query.ishome) {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/' })
            } else {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/saleRetrun/saleRetrunBill' })
            }

            // if (res.datalist) this.refresh(res.datalist)
          })
          .finally(() => (this.saving = false))
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          saleRetrunEntrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'SaleRetrun/SaleRetrunBill/GetSaleRetrunBill',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    handleOn: function() {
      // console.log(this.form, 'this.form')
      this.printValue = this.form.fid
    }
  }
}
</script>

<style lang="less" scoped>
.wlinfo {
  .el-input,
  .el-select,
  .el-autocomplete,
  .el-textarea {
    width: 20% !important;
  }
}
</style>
<style lang='less'>
.retrun-bill {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
